import { Component, Input, OnInit } from '@angular/core';
import { ProgramOfficeService } from 'src/app/core/service/program-office.service';

@Component({
  selector: 'app-booth-display',
  templateUrl: './booth-display.component.html',
  styleUrls: ['./booth-display.component.scss']
})
export class BoothDisplayComponent implements OnInit {

  @Input() type: string;
  @Input() id:any;

  booths: any[] = [];

  constructor(private programOfficeService: ProgramOfficeService) { }

  ngOnInit(): void {
    if (this.type && this.id) {
      this.getBoothost(this.type, this.id);
    }
  }

  getBoothost(type: string, id) {
    this.programOfficeService.getPrimaryEventsBooth(type, id).subscribe((res: any) => {
      this.booths = res;
    });
  }
}
